import { getCategoryProperties, updateCategoryProperties } from "../../../../redux/methods/categories";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import KeyValueGrid, { KeyValueItem } from "./KeyValueGrid";
import Button from "reactstrap/lib/Button";
import Spinner from "reactstrap/lib/Spinner";

export type CategoryEditPropertiesProperties =
{
    categoryId: string | null
    getCategoryProperties: (categoryId: string) => Promise<{ payload: string } | undefined>
    updateCategoryProperties: (formData: { categoryId: string; properties: object }) => Promise<any>
}

export function CategoryEditProperties
(
    {
        categoryId,
        getCategoryProperties,
        updateCategoryProperties
    }
    : CategoryEditPropertiesProperties
)
{
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [items, setItems] = useState<KeyValueItem[]>([]);
    useEffect(() =>
    {
        if (!categoryId) { return; }
        const load = async () =>
        {
            setLoading(true);
            try
            {
                const result = await getCategoryProperties(categoryId);
                const payloadRaw = result?.payload ?? '{}';
                const propsObject = JSON.parse(payloadRaw) as Record<string, any>;
                const entries = Object.entries(propsObject) as [string, any][];
                const gridItems: KeyValueItem[] = entries.map(([k, v]) => ({ key: k, value: String(v ?? '')}));
                setItems(gridItems);
            }
            finally
            {
                setLoading(false);
            }
        };
        load();
    },
    [categoryId, getCategoryProperties]);
    const handleSave = async () =>
    {
        if (!categoryId) { return; }
        setSaving(true);
        try
        {
            const jsonObject: Record<string, string> = {};
            for (const item of items)
            {
                if (item.key.trim() === '') { continue; }
                jsonObject[item.key.trim()] = item.value;
            }
            await updateCategoryProperties({ categoryId, properties: jsonObject });
        }
        catch (error)
        {
            console.error("Error saving category properties:", error);
        }
        finally
        {
            setSaving(false);
        }
    };
    if (!categoryId)
    {
        return <div className="p-3 text-muted">Brak wybranej kategorii.</div>;
    }
    const element =
    <div className="p-3">
        {loading ? (
            <Spinner size="sm" />
        ) : (
            <>
                <KeyValueGrid
                    items={items}
                    onChange={setItems}
                    addLabel="Dodaj właściwość"
                    keyPlaceholder="Nazwa właściwości"
                    valuePlaceholder="Wartość"
                />
                <div className="mt-3">
                    <Button
                        color="primary"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? <Spinner /> : 'Zapisz'}
                    </Button>
                </div>
            </>
        )}
    </div>;
    return element;
}

const mapStateToProps = () =>
{
    return {};
};

const mapDispatch =
{
    getCategoryProperties,
    updateCategoryProperties
};

export default connect(mapStateToProps, mapDispatch)(CategoryEditProperties);